import React, { useState } from 'react';

/**
 * Ein wiederverwendbares Modal-Popup, um einen neuen Agendapunkt (oder Unterpunkt) vorzuschlagen.
 */
const AgendaProposalModal = ({ isOpen, onClose, onSubmit }) => {
  const [description, setDescription] = useState('');

  const handleSubmit = () => {
    if (description.trim()) {
      onSubmit(description.trim());
      setDescription(''); // Formular zurücksetzen
      onClose();
    }
  };

  // Nicht rendern, wenn nicht geöffnet
  if (!isOpen) return null;

  return (
    <div 
        className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4" 
        onClick={onClose}
    >
      <div 
        className="bg-white dark:bg-gray-800 p-6 rounded-2xl shadow-xl w-full max-w-lg mx-auto" 
        onClick={(e) => e.stopPropagation()}
      >
        <h3 className="text-2xl font-bold mb-4 text-gray-900 dark:text-white">Neuen Agendapunkt vorschlagen</h3>
        <textarea
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          placeholder="Beschreiben Sie hier Ihren Vorschlag..."
          className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:text-white resize-y min-h-[100px]"
          rows="4"
        />
        <div className="flex justify-end space-x-3 mt-4">
          <button
            type="button"
            onClick={onClose}
            className="px-5 py-2 bg-gray-300 text-gray-800 rounded-lg hover:bg-gray-400 font-medium"
          >
            Abbrechen
          </button>
          <button
            type="button"
            onClick={handleSubmit}
            className="px-5 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium transition-colors disabled:opacity-50"
            disabled={!description.trim()}
          >
            Vorschlag einreichen
          </button>
        </div>
      </div>
    </div>
  );
};

export default AgendaProposalModal;